import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { 'Content-Type': 'application/json' } });

export const submitContact = (data) => api.post('/contact', data).then(r => r.data);
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then(r => r.data);
export const applyCareer = (data) => api.post('/careers/apply', data).then(r => r.data);
export const fetchNews = () => api.get('/news').then(r => r.data.items);
export const fetchNewsBySlug = (slug) => api.get(`/news/${slug}`).then(r => r.data);
export const fetchJobs = () => api.get('/jobs').then(r => r.data.items);
export const fetchJobBySlug = (slug) => api.get(`/jobs/${slug}`).then(r => r.data);
export const fetchSubmissions = (type) => api.get('/admin/submissions', { params: type ? { type } : {} }).then(r => r.data);
